import script from "./MerchantItemTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantItemTable.vue?vue&type=script&setup=true&lang=js"

import "./MerchantItemTable.vue?vue&type=style&index=0&id=6ab7b718&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab7b718"]])

export default __exports__